import { ROOT_URL } from "actions/config";
import compareVersions from "compare-versions";
import { UCC } from "constant/board";
import {
    ADBALLOON_URL,
    AFREECATV_DOMAIN,
    AFREECATV_URL,
    ITEM_MOBILE_URL,
    LOGIN_URL,
    NOTE_MOBILE_URL,
    NOTE_URL,
    OLD_LIVE_DOMAIN,
    PROFILE_IMG_DOMAIN,
    STATION_SSL_URL,
    VOD_PLAYER_SSL_URL,
} from "constant/config";
import { getDefaultMessage } from "constant/error";
import { COMMENT_HASH, COMMENT_HASH_NOTI, REPLY_HASH, REPLY_HASH_NOTI } from "constant/hash";
import { POST } from "constant/method";
import { toastr } from "components/toastr";
import i18next from "i18next";
import querystring from "querystring";
import cookie from "react-cookies";
import { isAndroid, isEdge, isIE, isIOS, isMacOs, isMobile, isWindows, osVersion, mobileModel } from "react-device-detect";
import store from "store";
import axios from "libs/axios";
import Adjust from "@adjustcom/adjust-web-sdk";

export function displayNumber(num = 0) {
    const lang = document.documentElement.lang;

    let si = [
        { value: 1, symbol: "" },
        { value: 1e3, symbol: i18next.t("k") },
        { value: 1e4, symbol: i18next.t("chỉ một") },
        { value: 1e8, symbol: i18next.t("100 triệu") },
    ];

    // 영여, 태국, 베트남어는 천/백만 단위
    if (["vi", "en", "th"].indexOf(lang) > -1) {
        si = [{ value: 1, symbol: "" }, { value: 1e3, symbol: i18next.t("k") }, { value: 1e6, symbol: i18next.t("triệu") }];
    }

    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    let i;
    for (i = si.length - 1; i > 0; i--) {
        if (num >= si[i].value) {
            break;
        }
    }

    return (num / si[i].value).toFixed(1).replace(rx, "$1") + si[i].symbol;
}

export function formatBytes(a, b) {
    if (0 === a) return "0 Bytes";
    let c = 1024,
        d = b || 2,
        e = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
        f = Math.floor(Math.log(a) / Math.log(c));
    return parseFloat((a / Math.pow(c, f)).toFixed(d)) + " " + e[f];
}

export function makeStationImageHtml(szUrl) {
    return '<div><img src="' + szUrl + '" class="image"><p/></div>';
}

/**
 * 배열을 size 조각으로 나눔
 * @param array items
 * @param integer size
 */
export function chunksItems(items, size = 4) {
    if (!items || items.length === 0) {
        return [];
    }
    let ul = [];

    for (let i = 0; i < items.length; i += size) {
        ul.push(items.slice(i, size + i));
    }
    return ul;
}

/**
 * 줄바꿈을 <br> 태그로 변경
 * @param string str
 */
export function nl2br(str) {
    return str && str.replace(new RegExp("\r?\n", "g"), "<br />");
}

export function classSwitch(pcClassName, mobileClassName) {
    return isMobile ? mobileClassName : pcClassName;
}

/**
 * 로컬 세션 저장
 * @param {*} keyName
 * @param {*} defaultValue
 */
export function getSessionItem(keyName, defaultValue) {
    let value = sessionStorage.getItem(`${global.bj_id}_${keyName}`);
    if (value) {
        return JSON.parse(value);
    } else {
        return defaultValue;
    }
}
export function setSessionItem(keyName, keyValue) {
    if (keyValue === undefined) {
        return false;
    }
    sessionStorage.setItem(`${global.bj_id}_${keyName}`, JSON.stringify(keyValue));
    return keyValue;
}

/**
 * 초를 시간으로 표시
 * @param {*} seconds
 */
export function secondToTime(sec) {
    let hours = Math.floor(sec / 3600);
    let minutes = Math.floor((sec - hours * 3600) / 60);
    let seconds = Math.floor(sec) - hours * 3600 - minutes * 60;
    let time = "";

    if (hours !== 0) {
        time = hours + ":";
    }

    time += minutes < 10 ? "0" + minutes : String(minutes);
    time += ":";
    time += seconds < 10 ? "0" + seconds : String(seconds);
    return time;
}

export const getLogoutUrl = () => {
    if (isWebview) {
        return `onlive://logout`;
    } else {
        return `${LOGIN_URL}/app/LogOut.php?request_uri=${window.encodeURIComponent(window.location.href)}`;
    }
};

export const isWebview = (() => {
    var uagent = navigator.userAgent.toLocaleLowerCase();
    return uagent.indexOf("afreeca webview") > -1 || uagent.indexOf("onlive webview") > -1 ? true : false;
})();

export const getWebviewVersion = () => {
    var uagent = navigator.userAgent.toLocaleLowerCase();
    var regex = /(onlive|afreeca) webview\d?\/(\d+\.\d+\.\d+)/gi;
    var matchs = regex.exec(uagent);
    return matchs ? matchs[2] : null;
};

// 안드로이드 웹뷰 체크
export const isAndroidWebview = () => {
    return isAndroid && isWebview;
};

// 안드로이드 웹뷰 + 아프리카 앱 버전 분기
export const getAndroidCompareVersion = (version) => {
    return isAndroid && isWebview && (compareVersions(getAppVersion(), version) >= 0);
};

export const isKitkat = (() => {
    return isAndroid && osVersion.indexOf("4.4") === 0 ? true : false;
})();

export const checkSupportUpload = () => {
    if (isWebview && isKitkat) {
        alert("Android 4.4 Phiên bản là tài liệu tải lên Chức năng Không cung cấp không.\nnền tảng Web Như một trình duyệt Vui lòng sử dụng nó ước.");
        return false;
    }
    return true;
};

/**
 * 쪽지보내기
 * @param {string} list
 */
export const sendNote = (list) => {
    const { is_login } = store.getState().authenticationReducer;
    if (is_login) {
        if (isMobile) {
            let szUserId = list;
            window.open(`${NOTE_MOBILE_URL}/${szUserId}`);
        } else {
            let szUserId = "";
            if (typeof list === "object") {
                szUserId = list.join(",");
            } else if (typeof list === "string") {
                szUserId = list;
            } else {
                console.error("The ID must be String or Array to send mail.");
                return false;
            }
            let oWindow = window.open(
                `${NOTE_URL}&id_list=${szUserId}`,
                "noteWriteWindow",
                "left=10,top=10,width=400,height=440,marginwidth=0,marginheight=0,resizable=0,scrollbars=no",
            );
            if (!oWindow) alert(i18next.t("Bị chặn Pop -up Vui lòng cho phép nó."));
            else oWindow.focus();
        }
    } else {
        if (window.confirm(i18next.t("Đăng nhập Yêu cầu. đăng nhập bạn sẽ làm điều đó?"))) {
            goLogin();
        }
    }
};

/**
 * 방송국 URL
 * @param {*} user_id
 */
export const getStationUrl = (user_id) => {
    return `${STATION_SSL_URL}/${user_id}`;
};

/**
 * unicode를 문자로 변경
 * @param {*} user_id
 */
export function uniCodeToChrs(str) {
    const regex = /&#([0-9]{3,6});/g;
    const newstr = str.replace(regex, function(str, p1) {
        return String.fromCharCode(parseInt(p1, 10));
    });
    return newstr;
}

export const getSysType = () => {
    if (isMobile) {
        return isIOS ? "ios" : "aos";
    } else {
        return "web";
    }
};

export const isSupportPlayStoreInApp = () => {
    const isPlayStore = inAppPlayStore();

    return (isPlayStore == "Y" && isAndroid && isWebview);
}

/**
 * 구독하기
 * @param {*} bj_id
 */
export const popupSubscription = async (bj_id) => {
    if (!isWebview) {
        // 웹
        window.open(
            `//point.onlive.vn/subscription/buy/${bj_id}?itemId=67&payType=STATION&location=station`,
            "gift_popup",
            "width=547,height=877,scrollbars=yes",
        );
    } else {
        popupSubscriptionMobile();
    }
};

/**
 * 구독하기 인앱결제
 * @param {*} bj_id 
 * @returns 
 */
 export const popupSubscriptionMobile = async () => {
    const { station = {}, profile_image = "" } = store.getState().stationReducer.stationInfo.data;
    const { user_nick = "" } = station;
    const { user_id } = store.getState().authenticationReducer;
    /*
     * AOS(기존) iOS(신규) 구독 버튼 추가 및 구독 페이지 UI 연결
     * 공통 파라미터 : receiverId, receive_nick, iOS : bj_image (프로필 이미지)
     */

    try {
        /**
         * 구독 flow
         * 1. 선물받은 구독권 보유 여부(api/subscription/a/info) 확인
         * 2. 없을 경우 마켓, 인앱 결제 활성화 체크
         * 3. 활성화 여부 Y 일 경우 구독 스킴 open
         */

        /**
         * 22-03-04 Google InApp 결제 작업에서 Android도 bj_image 추가
         * 구독 정보 API(subscription/a/info) Android 앱 내부에서도 호출 하고 있어 제거 예정. is_subscribe 파라미터 추가
         */

        let subscription_url = `onlive://item/subscription?receiverId=${station.user_id}&receive_nick=${encodeURIComponent(station.user_nick)}&bj_image=${encodeURIComponent("https:" + profile_image)}`;

        /* if (isIOS) {
            let url = "https:" + profile_image;
            subscription_url += `&bj_image=${encodeURIComponent(url)}`;
        } */

        const { result = -1, data = [] } = await axios.post(`${ITEM_MOBILE_URL}/api/subscription/a/info`, querystring.stringify({bj_id: global.bj_id}));
        
        const {
            subscription_type = "",
            subscription_ticket_type = "",
            first_payment_date = "",
            expire_payment_date = "",
            rest_payment_date = 0,
            hold_flag = 0,
            prod_name = "",
            svc_coupon = "",
            message = "",
        } = data;

        /**
         * subscription_type: auto 자동결제 / ticket: 구독한 경우
         * hold_flag: 선물받은 구독권 유무 0(없음) 1(있음)
         */

        // 오류 발생 시
        if (result === -1) {
            throw new Error(message);
        }

        if (result === -1102) {
            const { regist_date = "", regist_term_date = "" } = data;
            let msg = i18next.t("{{user_nick}}Nim dịch vụ Sử dụng Cấm\nĐặt mua con số không tồn tại.\n\n", { user_nick : user_nick });
            msg += i18next.t("Đình chỉ") + ` : `;
            msg += `${regist_date}\n`;
            msg += i18next.t("Haeil") + ` : `;
            msg += `${regist_term_date}`;
            throw new Error(msg);
        }
        
        /**
           월 정기결제, 정기 구독권 : 얼럿 미노출 및 구독페이지 이동 o
         */

        // AOS 일 경우에 인앱 결제 어드민 요청   
        if (isAndroid) {
            const isActiveInApp = await getActiveInAppPayment() || false;
            const isPlayStore = inAppPlayStore();
            const store = inAppStore();
            subscription_url += `&activeInApp=` + (isActiveInApp && (isPlayStore == "Y" ? true : false));
            subscription_url += `&isSubscribed=` + (subscription_type == null || subscription_type === "" ? false : true);

            if(store) {
                subscription_url += `&store=` + store;
            }
        } 

        // 자동 결제 OR 선물 받은 구독권이 없을 경우 
        if (subscription_type === "auto" || hold_flag === 0) {
            // InApp 여부에 따른 구독 스킴 ON/OFF
            window.location.href = subscription_url;
            return;
        }

        // 선물받은 구독권이 있을 경우
        let msg = "";
        if (subscription_type === "ticket") {
            msg = i18next.t("Tôi có vé đăng ký quà tặng có thể được sử dụng bởi {{user_nick}}.\n\n", { user_nick : user_nick });
            msg += i18next.t("Vé đăng ký đang sử dụng: ") + ` : `;
            msg += `${subscription_ticket_type}\n`;
            msg += i18next.t("Thời gian đăng ký") + ` : `;
            msg += `${first_payment_date} ~ ${expire_payment_date}\n`;
            msg += i18next.t("(Số ngày còn lại : {{rest_payment_date}} ngày)", { rest_payment_date : rest_payment_date }) + `\n`;
            msg += i18next.t("Bạn có muốn sử dụng và đăng ký không?") + `\n\n`;
            msg += i18next.t("Vé đăng ký để sử dụng : ") + ` : `;
            msg += `${prod_name}`;
        } else {
            msg = i18next.t("Tôi có vé đăng ký quà tặng có thể được sử dụng bởi {{user_nick}}.\n\n", { user_nick : user_nick });
            msg += i18next.t("BJdàn diễn viên Đặt mua Phong chinh Cổng vào, Người đăng kí riêng tư trò chuyện màu sắc, tên nick, biểu tượng cảm xúc Những lợi ích Nhận con số có.\nTRONG Bạn có muốn đăng ký?\n\n");
            msg += i18next.t("Để sử dụng Đăng ký") + ` : `;
            msg += `${prod_name}`;
        } 

        // 선물 받은 구독권 사용
        if (!window.confirm(msg)) {
            window.location.href = subscription_url;
            return;
        }

        const { result: useResult = -1, data: useData = [] } = await fetchJson(
            `${ITEM_MOBILE_URL}/api/subscription/a/giftUse`,
            {
                method: POST,
                credentials: "include",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: querystring.stringify({ send_id: user_id, recv_id: global.bj_id, svc_coupon, location: "station" }),
            },
        );
        const { message: useMessage = "", item_name = "", period = "", remain_days = 0 } = useData;

        // 오류 발생 시
        if (useResult === -1) {
            throw new Error(useMessage);
        }

        msg = i18next.t("{{user_nick}}Cho bạn\nquà  đã nhận Quyền đăng ký Đã sử dụng.\n\n", { user_nick : user_nick });
        msg += i18next.t("Đang sử dụng Đăng ký") + ` : `;
        msg += `${item_name}\n`;
        msg += i18next.t("đặt mua Giai đoạn") + ` : `;
        msg += `${period}\n`;
        msg += i18next.t("(Còn lại : {{rest_payment_date}}Ngày)", { rest_payment_date : remain_days });

        alert(msg);        
    } catch (error) {
        toastr.error(error.message, {
            timeOut: 2000,
        });
    }
 }

/**
 * 스티커 선물
 */
export const popupGiftSticker = (bj_id) => {
    window.open(
        `//st.onlive.vn/app/pop_gift_sticker.php?szBjId=${bj_id}&sys_type=${getSysType()}&location=station`,
        "gift_popup",
        "width=320,height=240,scrollbars=yes",
    );
};

/**
 * 애드벌룬 후원하기
 */
export const goGiftAdBalloon = (bjId) => {
    const station_no = store.getState().stationReducer.stationInfo.data.station.station_no;
    let url = `${ADBALLOON_URL}/app/api/banner.php?broad_system=station&bj_id=${bjId}&station_no=${station_no}`;
    let openPopupId = null;
    if (isWebview) {
        //광고ID 추가
        const ua = navigator.userAgent;
        const ret = /adid=([0-9A-Za-z\-]+);/g.exec(ua);
        const adid = ret ? ret[1] : "ADID_DISABLED";
        const webviewUrl = `https:${url}&adid=${adid}`;

        // 안드로이드 웹뷰 (안드로이드 내 새창의 경우 버그가 존재하여 외부 브라우저로 이동)
        if (isAndroid) {
            /**
             * 안드로이드의 경우 모웹으로 넘어가기 때문에 애드벌룬 선물 처리 후 팝업창 종료가 아니라 유지하기 위해 파라미터 값 전달
             */
            const androidUrl = webviewUrl + `&os=aos_app`;
            // 선물 이벤트 외부 브라우저로 가는 이슈가 있어 방송국 웹뷰로 이동되도록 스킴 변경
            openPopupId = window.open(`onlive://browser/station?url=${encodeURIComponent(androidUrl)}`, "gift_popup", "width=508,height=636");
        } else {
            openPopupId = window.open(webviewUrl, "gift_popup", "width=508,height=636");
        }
    } else {
        // PC, 모바일 웹
        openPopupId = window.open(url, "gift_popup", "width=508,height=636");
    }

    return openPopupId;
};

/**
 * 별풍선 선물하기
 */
export const goGiftStarBalloon = (bjId) => {
    let openPopupId = null;

    if (!isMobile) {
        // 웹
        openPopupId = window.open(
            `//st.onlive.vn/app/gift_starballoon.php?szBjId=${bjId}&szWork=BJ_STATION&sys_type=web&location=station`,
            "gift_popup",
            "width=519,height=537,scrollbars=yes",
        );
        
    } else {
        if (isIOS && isWebview) {
            // IOS 모바일 앱 (별풍선 사용 시 심사 실패) 후원하기로 변경
            const params = {
                szBjId: bjId,
                nGiftNo: getSessionItem("nGiftNo") || "",
                szAppLocation: getSessionItem("szAppLocation") || "",
                r: Math.random(),
            };

            /**
             * 후원하기 페이지
             */
            let url = "https://m.onlive.vn/item/a/starballoongift";
            url += "?" + querystring.stringify(params);
            openPopupId = window.open(url);
        } else {
            /**
             * 별풍선 선물하기 페이지
             * 구글플레이 인앱 결제 isPlayStore header 추가
             * 안드로이드 특정 웹뷰(ex.onlive://browser/external) 호출 시 userAgent 값이 정상 전달 안되는 이슈 있음
             * 파라미터로 앱 버전 추가해서 전달
             */

            const version = getAppVersion();
            const isPlayStore = inAppPlayStore();
            const store = inAppStore();
            let url = `https://m.onlive.vn/item/a/starballoongift?szBjId=${bjId}&r=${Math.random()}`;
            if (isWebview) {
                //url = "http:" + url; // ios에서 onlive: 스킴 사용 시 http/https 스킴이 없을 경우 동작하지 않음
                url += "&ref=webview";
                url += '&isPlayStore=' + isPlayStore;
                url += '&appVersion=' + (compareVersions(version, "1.0.0") >= 0 ? version : 0);

                if(store) {
                    url += '&store=' + store;
                }

                url += '&szOsVer=' + osVersion;
                url += '&szModel=' + mobileModel;

                window.location.href = `onlive://browser/external?url=${encodeURIComponent(url)}`;
            } else {
                openPopupId = window.open(url);
            } 
        }
    }

    return openPopupId;
};

/**
 * 구글 플레이스토어 
 * inApp 결제 활성화 여부 체크
 */
export const getActiveInAppPayment = async () => {
    // 인앱 결제 활성화 체크 여부 확인
    const params = {
        work: "IN_APP",
        type: "subscription",
        os: "android",
        version: getAppVersion() 
    }

    const { RESULT = -1, DATA = [] } = await axios.get(`${OLD_LIVE_DOMAIN}/api/item_info/index.php`, { params });

    if (RESULT !== 1) {
        return false;
    }

    return DATA;
}

/*
 * 별풍선 / 애드벌룬 세레모니 API 조회
 */

export const getCeremony = async (itemType = "STARBALLON") => {
    const params = {
        item_type: itemType
    };

    try {
        const response = await axios.get(`${ROOT_URL}/${global.bj_id}/ceremony`, {params} );
        return response;

    } catch (error) {
        return false;
    }
}

/**
 * 시그니처, 스토리 텔링 이미지 조회
 * 시그니처 > 시그니처 이모티콘 등록
 * 스토링 텔링 > 100개 쏠때 나오는 별풍선 이미지
 */
export const getCeremonyImg = (oCeremony) => {
    const {giftType, giftCnt, ceremony_starballoon, ceremony_adballon_img } = oCeremony;
    const {signature_balloon, stars_balloon} = ceremony_starballoon;
    
    let imgUrl = "";
    let defaultImg = "";
    let isStoryTelling = false;
    let errorUrl = "//res.onlive.vn/new_player/items/" + (isMobile ? "thumb/balloon_" :"ba_step");
    if (giftType === "STARBALLOON" && giftCnt > 0) {
        if (signature_balloon) { // 시그니처 별풍선
            signature_balloon.forEach((list) => {
                if (Number(list.number) === Number(giftCnt)) {
                    imgUrl = list.imageUrl;
                    isStoryTelling = true;
                }
            });
        }

        if (stars_balloon) { // 스타즈 별풍선
            stars_balloon.forEach((list) => {
                if (Number(list.number) === Number(giftCnt)) {
                    imgUrl = list.imageUrl;
                    isStoryTelling = true;
                }
            });
        }

        if (!signature_balloon && !stars_balloon) {
            // 스토리 텔링 없는 경우
            if (giftCnt > 0 && giftCnt < 10) { defaultImg = (isMobile ? '1.svg' : '1.png') }
            else if  (giftCnt >= 10 && giftCnt < 100) { defaultImg = (isMobile ? '2.svg' : '2.png' ) }
            else if  (giftCnt >= 100 && giftCnt < 500) { defaultImg = (isMobile ? '3.svg' : '3.png' ) }
            else if  (giftCnt >= 500 && giftCnt < 1000) { defaultImg = (isMobile ? '4.svg' : '4.png' ) }
            else if  (giftCnt >= 1000) { defaultImg = (isMobile ? '5.svg' : '5.png' )}
            imgUrl = errorUrl + defaultImg;

            if(!isMobile) {
                isStoryTelling = true;
            }
        }
    }

    /**
     * 방송국 세레머니 이미지 모바일용으로 조회
     */
    if (giftType === "ADBALLOON" && giftCnt > 0 && ceremony_adballon_img !== "") {
        //imgUrl = `//res.onlive.vn/new_player/items/adballoon/ceremony/mobile_${giftCnt}.png`;
        imgUrl = `//res.onlive.vn/new_player/items/` + ceremony_adballon_img;
        isStoryTelling = true;
    }

    return {
        imgUrl: imgUrl,
        isStoryTelling: isStoryTelling
    };
}

/**
 * 시그니처 스토리 텔링 별풍선 애드벌룬 이미지 onError 기본 이미지 처리
 */
 export const handleCeremonyImgError = (e, giftType, giftCnt, defaultUrl = "") => {
    e.preventDefault();
    let defaultImg = "";
    let errorUrl = "//res.onlive.vn/new_player/items/" + (isMobile ? "thumb/balloon_" :"ba_step");
    if(giftType === 'STARBALLOON') {
        if (giftCnt > 0 && giftCnt < 10) { defaultImg = (isMobile ? '1.svg' : '1.png') }
        else if  (giftCnt >= 10 && giftCnt < 100) { defaultImg = (isMobile ? '2.svg' : '2.png' ) }
        else if  (giftCnt >= 100 && giftCnt < 500) { defaultImg = (isMobile ? '3.svg' : '3.png' ) }
        else if  (giftCnt >= 500 && giftCnt < 1000) { defaultImg = (isMobile ? '4.svg' : '4.png' ) }
        else if  (giftCnt >= 1000) { defaultImg = (isMobile ? '5.svg' : '5.png' ) }
    } 
    
    if (giftType === 'ADBALLOON') {
        //errorUrl = "//res.onlive.vn/new_player/items/img_gift_adballoon.png";
        errorUrl = "//res.onlive.vn/new_player/items/adballoon/ceremony/mobile_0_1.png";
        if(defaultUrl) {
            errorUrl = defaultUrl;
        }
    }
    e.target.src = errorUrl + defaultImg;
}


/**
 * 모바일 실명인증
 */
export const getRealname = () => {
    if (window.confirm(i18next.t("tương ứng Dịch vụ Sử dụng vì Trong Đạo luật Mạng thông tin và Truyền thông Theo sát Xác minh danh tính Yêu cầu.\nXác minh danh tính Bạn sẽ tiến hành?"))) {
        if (isWebview) {
            const realname_url = "https://auth.m.onlive.vn/realname";
            window.location = `onlive://realName/requireAuth?url=${window.encodeURIComponent(realname_url)}`;
        } else {
            window.open(`https://auth.m.onlive.vn/realname`);
        }
    }
};
/**
 * 로그인 페이지 URL
 */
export const getLoginUrl = () => {
    if (isWebview) {
        return `onlive://login/requireLogin`;
    } else if (isMobile) {
        return `https://auth.m.onlive.vn/login?url=${window.encodeURIComponent(window.location.href)}`;
    } else {
        return `${LOGIN_URL}/afreeca/login.php?szFrom=full&request_uri=${window.encodeURIComponent(window.location.href)}`;
    }
};
/**
 * 로그인 페이지
 */
export const goLogin = () => {
    window.location = getLoginUrl();
};
/**
 * 로그인 페이지
 */
export const goLogout = () => {
    if (isWebview) {
        return `onlive://logout`;
    } else {
        return `${LOGIN_URL}/afreeca/login.php?szFrom=full&request_uri=${window.encodeURIComponent(window.location.href)}`;
    }
};

export const getVodEditUrl = (vod) => {
    if (isMobile) {
        return `https://m.onlive.vn/vod/edit/a/index?szWork=edit_title&szLocation=station&nStationNo=${vod.station_no}&nBbsNo=${vod.bbs_no}&nTitleNo=${vod.title_no}`;
    } else {
        return `//stbbs.onlive.vn/vodupload/index.php?szWork=edit_title&szLocation=station&nStationNo=${vod.station_no}&nBbsNo=${vod.bbs_no}&nTitleNo=${vod.title_no}`;
    }
};

export const preview = (params) => {
    var popup = window.open("", "popPreview", "height=774, width=947, scrollbars=yes, resizeable=yes");
    if (popup == null) {
        alert(i18next.t("Xem trước'Là Trình duyệt bật lên khối thông thoáng sau đó Sử dụng để sử dụng con số có."));
        return;
    }
    var form = document.createElement("form");
    form.setAttribute("method", "post");
    form.setAttribute("action", "https://stbbs.onlive.vn/app/preview_bbs_new.php");
    form.setAttribute("target", "popPreview");

    Object.keys(params).forEach((key) => {
        var input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = params[key];
        form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

export const goLive = (broad) => (e) => {
    const { is_login } = store.getState().authenticationReducer;

    e.preventDefault();
    //block not login & drm broad
    if(!is_login && broad.is_drm){
        alert('Có thể sử dụng sau khi đăng nhập');
        return;
    }
    
    liveInflowLog(broad.user_id, broad.broad_no, ["separate", "station", "thumbnail"]);
    if (isWebview) {
        window.location = `onlive://player/live?user_id=${broad.user_id}&broad_no=${broad.broad_no}`;
    } else if (isMobile) {
        window.location = `https://m.onlive.vn/#/player/${broad.user_id}/${broad.broad_no}`;
    } else {
        window.open(`//play.onlive.vn/${broad.user_id}/${broad.broad_no}`);
    }
};

export const handleFetchErrors = (response) => {
    if (!response.ok) {
        return response.json().then((json) => {
            return Promise.reject(json);
        });
    }
    return response;
};

export const handleFailedToFetch = (error) => {
    return Promise.reject({
        message: getDefaultMessage(),
    });
};

export const fetchJson = (input, init) => {
    return fetch(input, init)
        .then(handleFetchErrors, handleFailedToFetch)
        .then((response) => response.json());
};

export const documentScrollTop = () => {
    const someElement = document.documentElement.scrollTop && isEdge === false ? document.documentElement : document.body;
    someElement.scrollTop = 0;
};

// 글자수 BYTE로
export const countByte = (word) => {
    var bytes = 0;
    let idx;
    for (idx = 0; idx < word.length; idx++) {
        if (word.charCodeAt(idx) > 128) {
            bytes += 2;
        } else {
            bytes += 1;
        }
    }
    return bytes;
};

/*
 * 문자열 nMax byte에 해당하는 문자의 갯수 구하기
 * data: 문자열
 * nMax: 문자열 최대 바이트수
 */
export const getTextCount = (data, nMax) => {
    var nBytes = 0;
    var nLength = 0;
    var nIdx = 0;
    for (nIdx = 0; nIdx < data.length; nIdx++) {
        if (data.charCodeAt(nIdx) > 128) {
            nBytes += 2;
            nLength++;

            if (nBytes > nMax) {
                nLength--;
                return nLength;
            }
        } else {
            nBytes++;
            nLength++;

            if (nBytes > nMax) {
                nLength--;
                return nLength;
            }
        }
    }
};

let change = false;
//error 발생하면 같은 메시지로는 업데이트 되지 않음
export const behindText = () => {
    change = !change;
    return change ? "" : String.fromCharCode(0x200b);
};

//error 발생하면 같은 메시지로는 업데이트 되지 않음
export const numberCommaString = (value) => {
    if (!value) {
        return 0;
    }
    if (isIE) {
        return Number(value)
            .toLocaleString()
            .replace(".00", "");
    } else {
        return Number(value).toLocaleString();
    }
};

export const getActiveNo = () => {
    const timestamp = new Date().getTime();
    return ((timestamp + 32400) / 86400) % 2;
};

export const getProfileImage = (user_id) => {
    return `${PROFILE_IMG_DOMAIN}/LOGO/${user_id.substr(0, 2)}/${user_id}/${user_id}.jpg`;
};

/**
 * IE11에서 localStorage가 안되는 경우가 있어 cookie로 맵핑합니다.
 * https://gist.github.com/juliocesar/926500
 */
export const localStorageFactory = (() => {
    try {
        return localStorage;
    } catch (e) {
        function Storage() {}
        Storage.prototype.setItem = function(sKey, sValue) {
            if (!sKey) {
                return;
            }
            document.cookie = escape(sKey) + "=" + escape(sValue) + "; expires=Tue, 19 Jan 2038 03:14:07 GMT; path=/";
        };
        Storage.prototype.getItem = function(sKey) {
            if (!sKey) {
                return null;
            }
            return unescape(
                document.cookie.replace(
                    new RegExp("(?:^|.*;\\s*)" + escape(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*((?:[^;](?!;))*[^;]?).*"),
                    "$1",
                ),
            );
        };
        Storage.prototype.removeItem = function(sKey) {
            if (!sKey || !this.hasOwnProperty(sKey)) {
                return;
            }
            document.cookie = escape(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
            this.length--;
        };
        Storage.prototype.clear = function() {};
        return new Storage();
    }
})();

export const getNickname = () => {
    const { stationInfo } = store.getState().stationReducer;
    const { data = {} } = stationInfo;
    const { station } = data;
    return station ? station.user_nick : "";
};

/**
 * CLICK로그
 */
export const setClickLogapi = (code_type, sendData, callback) => {
    let data = Object.assign({ sztype: "CLICK", code_type: code_type, send_data: querystring.stringify(sendData), sys_type: "web" });
    //로딩
    return fetch("//eventapi.onlive.vn/set_log_api.php", {
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: querystring.stringify(data),
        credentials: "include",
    })
        .then(callback)
        .catch(callback);
};

/**
 * Simply compares two string version values.
 *
 * Example:
 * versionCompare('1.1', '1.2') => -1
 * versionCompare('1.1', '1.1') =>  0
 * versionCompare('1.2', '1.1') =>  1
 * versionCompare('2.23.3', '2.22.3') => 1
 *
 * Returns:
 * -1 = left is LOWER than right
 *  0 = they are equal
 *  1 = left is GREATER = right is LOWER
 *  And FALSE if one of input versions are not valid
 *
 * @function
 * @param {String} left  Version #1
 * @param {String} right Version #2
 * @return {Integer|Boolean}
 * @author Alexey Bass (albass)
 * @since 2011-07-14
 */
export const versionCompare = function(left, right) {
    if (typeof left + typeof right != "stringstring") return false;

    var a = left.split("."),
        b = right.split("."),
        i = 0,
        len = Math.max(a.length, b.length);

    for (; i < len; i++) {
        if ((a[i] && !b[i] && parseInt(a[i]) > 0) || parseInt(a[i]) > parseInt(b[i])) {
            return 1;
        } else if ((b[i] && !a[i] && parseInt(b[i]) > 0) || parseInt(a[i]) < parseInt(b[i])) {
            return -1;
        }
    }

    return 0;
};

/**
 * 쿠키및 브라우져 셋팅 언어셋 리스트
 */
export const detectLanguages = () => {
    var langs = [cookie.load("_lang"), navigator.languages && navigator.languages[0], navigator.userLanguage];
    if (navigator.languages) {
        langs = langs.concat(navigator.languages.slice(1));
    }
    langs = langs.filter((val) => val); //없는 값 제거하는 필터링

    return langs;
};
/**
 * 지원가능한 언어셋
 */
export const allowLanguage = () => {
    const possibleLanguages = ["vi"];
    let langs = detectLanguages();

    for (let i = 0; i < langs.length; i++) {
        var lang = langs[i];
        lang = lang.replace("_", "-");

        //중국어예외처러
        if (["zh-hk", "zh-mo", "zh-hant"].indexOf(lang.toLowerCase()) > -1) {
            lang = "zh-TW";
        }

        if (possibleLanguages.indexOf(lang) >= 0) return lang;

        if (lang.indexOf("-") >= 0) {
            lang = lang.split("-")[0];
            if (possibleLanguages.indexOf(lang) >= 0) return lang;
        }
    }
    return "vi"; //기본값
};

export const liveInflowLog = (bj_id, broadNo, paths) => {
    inflowLog("LIVE", bj_id, broadNo, paths);
};
export const vodInflowLog = (bj_id, titleNo, paths) => {
    inflowLog("VOD", bj_id, titleNo, paths);
};
/**
 * 진입로그
 * @param {string} code_type 타입
 * @param {string} bj_id
 * @param {number} contentNo 콘텐츠번호
 * @param {array} paths
 */
export const inflowLog = (code_type, bj_id, contentNo, paths = []) => {
    let cookieName = "";
    let inflowLogData = [];
    const tmToday = new Date();
    const _au = cookie.load("_au");
    const path_key = _au + "_" + (!!contentNo && Number(contentNo) !== 0 ? contentNo : bj_id) + "_" + tmToday.getTime();
    const inflowPath = paths.reduce((accumulator, value, index) => {
        accumulator[`path${index + 1}`] = value;
        return accumulator;
    }, []);

    const sysType = isWebview ? "app" : isMobile ? "webm" : "web";
    const os = isWebview ? (isIOS ? "ios" : "aos") : isMacOs ? "mac" : "win";

    switch (code_type) {
        case "LIVE":
            cookieName = "LIN";
            inflowLogData = { bj_id, broad_no: contentNo, referer: window.location.href, ...inflowPath, os };
            break;
        case "VOD":
            cookieName = "VIN";
            inflowLogData = { bj_id, title_no: contentNo, referer: window.location.href, ...inflowPath, os };
            break;
        default:
            break;
    }

    /**
     * 쿠키셋팅
     */
    tmToday.setTime(tmToday.getTime() + 10 * 1000); //10초 후 만료
    const cookieValue = querystring.stringify({ path_key, ...inflowPath });
    cookie.save(cookieName, cookieValue, { path: "/", expires: tmToday, domain: AFREECATV_DOMAIN });

    /**
     * 예외처리 추가
     * - AOS, iOS 6.8.0 이상일 경우에만 웹에서 inflow_path는 안보내는 것으로 함 (6.7.0 이하 버전은 웹에서 보내짐)
     */
    if (!isWebview) {
        /**
         * 로그호출
         */
        fetch("//eventapi.onlive.vn/set_log_api.php", {
            method: "post",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: querystring.stringify({
                sztype: "INFLOW_PATH",
                code_type,
                path_key,
                send_data: querystring.stringify(inflowLogData),
                sys_type: sysType,
            }),
            credentials: "include",
        }).then(() => {});
    }
};

/**
 * 웹뷰이고 공유하기 가능한 버전인지
 */
export const isWebbiewShareable = () => {
    if (isWebview) {
        if (isAndroid) {
            return true;
        } else if (isIOS) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
};
/**
 * 방송국 post 공유
 * @param {*} post
 */
export const webviewSharePost = (post) => {
    webviewShare(getPostUrl(post), post.title_name);
};

/**
 * 방송국 재생목록 공유
 * @param playlist
 */
export const webviewSharePlaylist = (playlist) => {
    webviewShare(getPlaylistUrl(playlist), playlist.title);
};

/**
 * 공유
 * @param {*} post
 */
export const webviewShare = (url, title) => {
    window.location.href = `onlive://share?url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}`;
};

/**
 * 게시글  URL
 * @param {*} post
 */
export const getPostUrl = (post) => {
    if (post.board_type === UCC) {
        return `${VOD_PLAYER_SSL_URL}/${post.title_no}`;
    } else {
        return `${STATION_SSL_URL}/${global.bj_id}/post/${post.title_no}`;
    }
};

/**
 * 재생목록 url
 * @param playlist
 * @returns {string}
 */
export const getPlaylistUrl = (playlist) => {
    /**
     * 재생목록 첫번째 VOD가 삭제 된 경우 다음 VOD로 넘어갈 수 있도록 변경
     * bbs_title_no 가 아닌 vod_playlist_tbl.rep_title_no 로 참조
     */
    let { bbsTitle: post = {} } = playlist;
    post = post || {};
    return `${VOD_PLAYER_SSL_URL}/${playlist.rep_title_no || 0}/playlist/${playlist.idx}`;
};

/**
 * 웹뷰의 버전
 */
export const getAppVersion = () => {
    var aMatch = navigator.userAgent.toLocaleLowerCase().match(/(onlive|afreeca) webview\/([0-9.]+)/);
    return aMatch ? aMatch[1] : "1.0.0";
};

/**
 * 인앱 결제 가능 여부 app 내 header
 * @param {*} duration 
 */
export const inAppPlayStore = () => {
    const ua = navigator.userAgent;
    const isPlayStore = /isPlayStore=([yYnN]);?/gi.exec(ua) || '';

    return (isPlayStore !== '' ? isPlayStore[1].toUpperCase() : '');
}

export const youtubeDurationToSeconds = (duration) => {
    let hours = 0;
    let minutes = 0;
    let seconds = 0;

    // Remove PT from string ref: https://developers.google.com/youtube/v3/docs/videos#contentDetails.duration
    duration = duration.replace("PT", "");

    // If the string contains hours parse it and remove it from our duration string
    if (duration.indexOf("H") > -1) {
        let hours_split = duration.split("H");
        hours = parseInt(hours_split[0]);
        duration = hours_split[1];
    }

    // If the string contains minutes parse it and remove it from our duration string
    if (duration.indexOf("M") > -1) {
        let minutes_split = duration.split("M");
        minutes = parseInt(minutes_split[0]);
        duration = minutes_split[1];
    }

    // If the string contains seconds parse it and remove it from our duration string
    if (duration.indexOf("S") > -1) {
        let seconds_split = duration.split("S");
        seconds = parseInt(seconds_split[0]);
    }

    // Math the values to return seconds
    return hours * 60 * 60 + minutes * 60 + seconds;
};

export const gtag = (category, action, label, value) => () => {
    window.gtag("event", action, {
        event_category: category,
        event_label: label,
        value: value,
    });
};

/**
 * 다크모드 유뮤
 */
export const isDark = () => {
    return cookie.load("theme") === "dark" ? true : false;
};

/**
 * parsing boolean
 * @param value
 * @returns {boolean}
 */
export const parseBoolean = (value) => {
    if (typeof value === "undefined") {
        return false;
    }

    if (typeof value === "object") {
        return value !== null;
    }

    if (typeof value === "number" || typeof value === "bigint") {
        return value !== 0;
    }

    if (typeof value === "string") {
        return value.toLowerCase() !== "false";
    }

    if (typeof value === "boolean") {
        return value;
    }

    return true;
};

/**
 * 현재 플랫폼(OS) 조회
 */
export const getPlatForm = () => {
    let os = "";
    if (isMobile) {
        if (isAndroid) {
            os = "ANDROID";
        } else {
            os = "IOS";
        }
    } else {
        if (isWindows) {
            os = "WINDOWS";
        } else if (isMacOs) {
            os = "MAC";
        }
    }
    return os;
};

/**
 * 모바일 게시물 이미지 클릭허용 유무 (새창,확대기능)
 */
export const isImageOpenAllowed = () => {
    if (isMobile) {
        return true;
    } else {
        return false;
    }
};

/**
 * 복사 붙여넣기시 태그제외하기
 */
export const copyPasteEdit = (e, replace) => {
    e.preventDefault();
    e.stopPropagation();
    let clipboardData = e.clipboardData || window.clipboardData;
    let content = clipboardData.getData(isIE ? "text" : "text");
    if (isIE) {
        if (window.getSelection) {
            var newNode = document.createElement("span");
            newNode.innerHTML = content.replace(/(?:\r\n|\r|\n)/g, replace);
            var selRange = window.getSelection().getRangeAt(0);
            selRange.deleteContents();
            selRange.insertNode(newNode);
        }
    } else {
        content = content.replace(/(?:\r\n|\r|\n)/g, replace);
        document.execCommand("insertHtml", false, content);
        return false;
    }
}

export const fetchAdBalloonInfo = () => {
    let url = `${ADBALLOON_URL}/app/api/savings.php?type=info`;

    return fetch(url, {
        credentials: "include",
    })
        .then((response) => response.json());

}

export const getNotiHashRegExr = (state, type) => {

    switch (type) {
        case COMMENT_HASH:
            return state.match(/^(#comment)([0-9]+)$/) || '';
        case COMMENT_HASH_NOTI:
            return state.match(/^(#comment(_noti)?)([0-9]+)$/) || '';

        case REPLY_HASH:
            return state.match(/^(#reply)([0-9]+)$/) || '';
        case REPLY_HASH_NOTI:
            return state.match(/^(#reply(_noti)?)([0-9]+)$/) || '';

        default:
            break;
    }

    return '';
}
/**
 * 애드벌룬 이벤트 활성화되었는지 체크 
 */
export const getActiveEvent = async() => {
    const params = querystring.stringify({ type: "active_bj_check", bj_id: global.bj_id });
    let url = `${ADBALLOON_URL}/app/api/adballoon_event.php?${params}`;

    return await fetch(url, {
        credentials: "include",
    })
        .then((response) => response.json())
        .catch((error) => error);
}

/*
 * vod 플레이어 스킴
 */
export const getVodPlayerScheme = (station_no,bbs_no,title_no,file_type) => {    
    if (file_type === "CATCH") {
        
        let szListDataType = get_list_data_type("station"); //추천 데이터 로그

        let catchCreated = localStorageFactory.getItem("catchCreated") || true;
        catchCreated = parseBoolean(catchCreated);

        return `onlive://player/catch?station_no=${station_no}&bbs_no=${bbs_no}&title_no=${title_no}&type=${file_type}&szLocation=station${szListDataType}&station_id=${global.bj_id}&show_user_created=${catchCreated}`;
    }

    return `onlive://player/video?station_no=${station_no}&bbs_no=${bbs_no}&title_no=${title_no}&type=${file_type}`;
};

/*
 * 캐치 방송국 스킴에 들어갈 추천 데이터 타입
 * 방송국,채널 영역은 추천이 없으니 고정 데이터 들어감
 */
export const get_list_data_type = (detail_locatin="station") => {
    let szSchemeListData = "";
    let list_data_type = "";
    let list_data_detail = "";
    let rec_detail = "";

    switch(detail_locatin){
        case "station": //방송국
            list_data_type = 'bj_related';
            list_data_detail = '["bj_related"]';
            rec_detail = '{"bj_related":0.0}';
            break;
    }

    list_data_detail = encodeURI(list_data_detail);
    rec_detail = encodeURI(rec_detail);

    szSchemeListData = `&list_data_type=${list_data_type}&list_data_detail=${list_data_detail}&rec_detail=${rec_detail}`;

    return szSchemeListData;
};

export const inAppStore = () => {
    let uagent = navigator.userAgent;
    const store = /store\/([a-zA-Z]+);?/gi.exec(uagent) || '';

    return store ? store[1].toUpperCase() : false;
}

export function trackEvent(eventToken){
    if(eventToken){
        Promise.race([
            Adjust.trackEvent({ eventToken: eventToken }),
            new Promise((resolve, reject) => {
                setTimeout(() => reject(new Error("Timed out")), 5000);
            })
        ]);
    }
}